import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { FilterParamsType } from '@/api/helpers/apiParamsHelpers';

export const getInternalOrganizationBillingReportApi = async (
  data: FilterParamsType
): Promise<ApiResponseType<Blob>> => {
  const uri = '/organization/internal/events/wire/export-report/';

  return authApiService.GET_XLS(uri, data);
};
